import nl from './dictionaries/nl'
import en from './dictionaries/en'
import cw from './dictionaries/cw'
const dictionary = { nl, en, cw };

export default dictionary;
